

export default function QuizOption({ option, quizId, changeHandler, isQuizMark }) {

    const quizName = JSON.stringify({
        quizId: quizId,
        optionId: option.id
    })

    const quizID = `option-${option.id}_q-${quizId}`
    return <>
        {isQuizMark ?
            <div className={`rounded border ${option.isCorrect ? "bg-[#134E4A]" : "bg-[#1E293B]"} border-[#475569] p-4 font-semibold`}>
                {option.option}
            </div>
            :
            <label htmlFor={quizID}>
                <input className="quizLws" name={quizName} type="checkbox" id={quizID}
                    onChange={changeHandler}
                    tabIndex="0"
                />
                <span>{option.option}</span>
            </label>

        }

    </>
};